<template>
  <div class="check-wrap">
    <div class="show-check-wrap">
      <!-- 循环showCheckUpArr数组start -->
      <div v-for="(item,index) in showCheckUpArr" :key="index" class="table-wrap">
        <div v-if="index==0" class="table-header">
          <div
            v-for="(itemHead,indexHead) in item.touxinxi"
            :key="indexHead"
            :style="indexHead=='0'?'border-left: 1Px solid #EBEBEB;flex:'+itemHead.flex:'flex:'+itemHead.flex"
          >{{itemHead.title}}</div>
        </div>
        <div
          class="table-content"
          v-for="(neirongItem,neirongIndex) in item.neirong"
          :key="neirongIndex"
        >
          <div
            v-for="(childItem,childIndex) in neirongItem"
            :key="childIndex"
            :style="childIndex=='0'?'border-left: 1Px solid #EBEBEB;flex:'+childItem.flex:'flex:'+childItem.flex"
          >
            <div v-if="childItem.key=='caozuo'" class="fun-btn-style">
              <!-- <div :data-index="childIndex">查看</div>-->
              <div v-if="headerUserRest.status==2 && childItem.status =='9'" :data-index="childIndex" @click="adminCheckReportRecall(neirongItem[0].value)">作废</div>
              <div v-if="headerUserRest.status==2 && childItem.status =='13'" style="background:#999" :data-index="childIndex"><span>作废</span></div>
            </div>
            <div :title="childItem.value" :class="{'name':childItem.key=='name'}" v-else>{{childItem.value}}</div>
          </div>
        </div>
      </div>
      <div class='total-price' v-if="totalPrice>0">合计：{{totalPrice}} 元</div>
      <!-- 循环showCheckUpArr数组end -->
    </div>

    <div v-if="headerUserRest.status==2" class="create-check-wrap" @keydown="changeSuggestTabEvent">
      <div class="title-info">
        <p>检查单</p>
        <div>
          <div @click="deleteInputData">删除</div>
          <div @click="showSaveModalFun">保存</div>
        </div>
      </div>
      <div class="table-header">
        <div class="select-box">
          <input class="all-check-up-box" type="checkbox" @click="checkAllIndex">
        </div>
        <div
          v-for="(item,index) in columns"
          :key="index"
          :style="item.key=='name'?'flex:2;border-top: 1Px solid #EBEBEB;':'border-top: 1Px solid #EBEBEB;'"
        >{{item.title}}</div>
      </div>
      <div class="table-content" v-for="(item,index) in inputData" :key="index" >
        <div class="select-box">
          <input
            class="check-up-box-style"
            :data-inputdataindex="index"
            type="checkbox"
            @click="checkIndex"
          >
        </div>
        <div class="XiangMuMing-relative" v-for="(childItem,childIndex) in item" :key="childIndex" :style="'flex:'+childItem.flex+';'+(childItem.show==false?'display:none':'')">
          <input
            v-if="childItem.tagType=='input' && childItem.show"
            type="text"
            v-model="childItem.value"
            :data-key="childItem.key"
            :data-index="index"
            @keydown.enter="enterEvent"
            @input="inputEvent"
            @focus="inputFocus"
            oninput = "if(this.dataset.key=='count'){ value = (/^[1-9]\d{0,1}$/).test(value)?value:''}"
            :title="childItem.value"
          >
          <div v-if="childItem.tagType=='div' && childItem.show"
            :data-key="childItem.key"
            :data-index="index"
            @click="clickEvent"
          >{{childItem.value}}</div>

          <!-- 项目名称联想弹出层 -->
          <div
            v-if="showSuggestnameTab && index == inputIndex && childItem.key == 'name'"
            class="suggest-pop-wrap"
            @click="suggestTabDataClick"
          >
            <Col class="demo-spin-col" span="8" v-show="suggestnameDataLoading == true && suggestnameData.length<=0">
                <Spin fix>加载中...</Spin>
            </Col>
            <div
              v-for="(item,index) in suggestnameData"
              :key="index"
              :style="index==checkedIndex?'background: #DAECFB':''"
              :data-index="index"
              @mouseenter="mouseenterEvent"
            >{{item}}</div>
          </div>
          <!-- 项目名称联想弹出层 -->
          <!-- 执行科室弹出层 -->
          <div
            v-if="showSuggestexeDeptPop && index == inputIndex && childItem.key == 'exeDept'"
            class="suggest-pop-wrap"
            @click="suggestexeDeptClick"
          >
            <div
              v-for="(item,index) in suggestexeDeptData"
              :key="index"
              :style="index==checkedIndex?'background: #DAECFB':''"
              :data-index="index"
              @mouseenter="mouseenterEvent"
            >{{item}}</div>
          </div>
          <!-- 执行科室弹出层 -->
          <!-- 部位弹出层 -->
          <div
            v-if="showSuggestbodyPop && index == inputIndex && childItem.key == 'body'"
            class="suggest-pop-wrap"
            @click="suggestbodyClick"
          >
            <div
              v-for="(item,index) in suggestbodyData"
              :key="index"
              :style="index==checkedIndex?'background: #DAECFB':''"
              :data-index="index"
              @mouseenter="mouseenterEvent"
            >{{item}}</div>
          </div>
          <!-- 部位弹出层 -->

        </div>

      </div>
      <div class="total-price-style" v-if="buttomTotalPriceIsShow">合计：{{buttomTotalPrice}}元</div>
    </div>
    <!-- 保存确认框 -->
    <div v-if="showSaveModal" class="ivu-modal-wrap" style="z-index: 1008;background:rgba(55,55,55,.6);display:flex;justify-content:center;align-items:center" @click="showSaveModal=false">
      <div style="width:18vw;height:20vh;background:#fff;padding:3vh;border:1px solid #666">
        <div style="width:100%;height:100%;display:flex; flex-direction: column;justify-content: space-around">
          <p style="text-align:center;">确认保存?</p>
          <div style="display:flex;justify-content:space-between;align-items:center;">
            <div style="display:flex;justify-content:center;align-items:center;width:6vw;height:4vh;background:blue;color:#fff;border-radius:3px;background:#72BEFF;cursor: pointer;" @click="addInputData">
              确认
            </div>
            <div style="display:flex;justify-content:center;align-items:center;width:6vw;height:4vh;color:#fff;border-radius:3px;background:#aeb8c1;cursor: pointer;" @click="showSaveModal=false">
              取消
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- 保存确认框end -->
  </div>
</template>

<script>
/*
因为有元素操作，所有的键名必须唯一，比如数量这个键名count，同样的数量键名不能都是count
*/

import {
  api
} from '@/services'

import {mapGetters} from 'vuex'
export default {
  data () {
    return {
      showSaveModal: false,
      totalPrice: '0.00',
      // 低部合计金额
      buttomTotalPrice: '0.00',
      buttomTotalPriceIsShow: false,
      // 输入位置检查单头信息
      columns: [
        {
          title: '项目名称',
          key: 'name'
        },
        {
          title: '执行科室',
          key: '执行科室'
        },
        {
          title: '部位',
          key: 'body'
        },
        {
          title: '单价（元）',
          key: 'price'
        },
        {
          title: '数量',
          key: 'count'
        },
        {
          title: '金额（元）',
          key: 'jine'
        },
        {
          title: '备注',
          key: 'beizhu'
        }
      ],
      // 展示位置检查单头信息
      headerColumns: [
        {
          title: '检查单号',
          key: 'code'
        },
        {
          title: '状态',
          key: 'jianChaDanStatus'
        },
        {
          title: '项目名称',
          key: 'name'
        },
        {
          title: '执行科室',
          key: 'exeDept'
        },
        {
          title: '部位',
          key: 'body'
        },
        {
          title: '开单科室',
          key: 'kaidankeshi'
        },
        {
          title: '开单医生',
          key: '开单医生'
        },
        {
          title: '开单时间',
          key: 'time'
        },
        {
          title: '单价（元）',
          key: 'price'
        },
        {
          title: '数量',
          key: 'count'
        },
        {
          title: '金额（元）',
          key: 'jine'
        },
        {
          title: '备注',
          key: 'beizhu'
        },
        {
          title: '操作',
          key: 'caozuo'
        }
      ],
      // 展示检查单数组
      showCheckUpArr: [
        {
          touxinxi: [
            {
              title: '检查单号',
              key: 'code',
              flex: 1.5
            },
            {
              title: '状态',
              key: 'jianChaDanStatus',
              flex: 1
            },
            {
              title: '项目名称',
              key: 'name',
              flex: 1.5
            },
            {
              title: '执行科室',
              key: 'exeDept',
              flex: 1
            },
            {
              title: '部位',
              key: 'body',
              flex: 0.8
            },
            {
              title: '开单科室',
              key: 'kaidankeshi',
              flex: 1
            },
            {
              title: '开单医生',
              key: 'kaidanyisheng',
              flex: 1
            },
            {
              title: '开单时间',
              key: 'time',
              flex: 1.8
            },
            {
              title: '单价(元)',
              key: 'price',
              flex: 0.8
            },
            {
              title: '数量',
              key: 'count',
              flex: 0.8
            },
            {
              title: '金额(元)',
              key: 'jine',
              flex: 0.8
            },
            {
              title: '备注',
              key: 'beizhu',
              flex: 1
            },
            {
              title: '操作',
              key: 'caozuo',
              flex: 1
            }
          ],
          neirong: [
            [
              {
                value: '',
                key: 'code',
                tagType: 'input', // 是否是输入框
                show: true,
                flex: 1.5
              },
              {
                value: '',
                key: 'jianChaDanStatus',
                tagType: 'div', // 是否是输入框
                show: true,
                flex: 1
              },
              {
                value: '',
                key: 'name',
                tagType: 'div', // 是否是输入框
                show: true,
                flex: 1.5
              },
              {
                value: '',
                key: 'exeDept',
                tagType: 'input', // 是否是输入框
                show: true,
                flex: 1
              },
              {
                value: '',
                key: 'body',
                tagType: 'input', // 是否是输入框
                show: true,
                flex: 0.8
              },
              {
                value: '',
                key: 'kaidankeshi',
                tagType: 'input', // 是否是输入框
                show: true,
                flex: 1
              },
              {
                value: '',
                key: 'kaidanyisheng',
                tagType: 'input', // 是否是输入框
                show: true,
                flex: 1
              },
              {
                value: '',
                key: 'time',
                tagType: 'input', // 是否是输入框
                show: true,
                flex: 1.8
              },
              {
                value: '',
                key: 'price',
                tagType: 'div', // 是否是输入框
                show: true,
                flex: 0.8
              },
              {
                value: '',
                key: 'count',
                tagType: 'input', // 是否是输入框
                show: true,
                flex: 0.8
              },
              {
                value: '',
                key: 'jine',
                tagType: 'div', // 是否是输入框
                show: true,
                flex: 0.8
              },
              {
                value: '',
                key: 'beizhu',
                tagType: 'input', // 是否是输入框
                show: true,
                flex: 1
              },
              {
                value: '操作',
                key: 'caozuo',
                tagType: 'div', // 是否是输入框
                show: true,
                flex: 1
              }
            ]
          ]
        }
      ],
      // 检查单空数据
      baseData: [
        {
          value: '',
          key: 'name',
          tagType: 'input', // 是否是输入框
          show: true,
          flex: 2
        },
        {
          value: '',
          key: 'exeDept',
          tagType: 'div', // 是否是输入框
          show: true,
          flex: 1
        },
        {
          value: '',
          key: 'body',
          tagType: 'div', // 是否是输入框
          show: true,
          flex: 1
        },
        {
          value: '',
          key: 'price',
          tagType: 'div', // 是否是输入框
          show: true,
          flex: 1
        },
        {
          value: '',
          key: 'count',
          tagType: 'input', // 是否是输入框
          show: true,
          flex: 1
        },
        {
          value: '',
          key: 'jine',
          tagType: 'div', // 是否是输入框
          show: true,
          flex: 1
        },
        {
          value: '',
          key: 'jianchadanbeizhu',
          tagType: 'input', // 是否是输入框
          show: true,
          flex: 1
        },
        {
          value: '',
          key: 'code',
          tagType: 'input', // 是否是输入框
          show: false,
          flex: 1
        },
        {
          value: '',
          key: 'itemType',
          tagType: 'input', // 是否是输入框
          show: false,
          flex: 1
        },
        {
          value: '',
          key: 'itemSubType',
          tagType: 'input', // 是否是输入框
          show: false,
          flex: 1
        }
      ],
      // 发送的数据模板
      submitBaseData: [],
      // 需要添加的检查单信息
      inputData: [],
      // 选中的检查单数组(全选，单选)
      checkedIndexArr: [],
      // 项目名称联想假数据
      suggestTabData: [
        {
          name: '',
          exeDept: '',
          body: '',
          price: '',
          count: '',
          jine: ''
        }
      ],
      // 项目名称假数据
      suggestnameDataLoading: true,
      suggestnameData: [],
      // 执行科室假数据
      suggestexeDeptData: [],
      // 部位假数据
      suggestbodyData: [],
      // 弹层数据length
      popDataLength: 0,
      // 输入项目名称哪一个行的index
      inputIndex: 0,
      // 是否展示联想项目名称表格
      showSuggestnameTab: false,
      // 是否展示执行科室的弹层
      showSuggestexeDeptPop: false,
      // 是否展示部位的弹层
      showSuggestbodyPop: false,
      // 选中的联想药品的index
      checkedIndex: 0,
      // 联想层定位y
      suggestTabDataTop: 0,
      // 联想层定位x
      suggestTabDataLeft: 0
    }
  },
  methods: {
    // 获取焦点，改变当前输入行index
    inputFocus (e) {
      this.inputIndex = e.target.dataset.index
    },
    // 检验报告作废
    adminCheckReportRecall (reportId) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认作废</p>',
        onOk: () => {
          api.adminCheckReportRecall({
            data: {
              params: {
                recipeId: reportId
              }
            }
          }).then(res => {
            if (res.code == '0') {
              this.$Message.success('作废成功')
            } else {
              // this.$Message.error('作废失败')
            }
            this.checkReportList()
          })
        },
        onCancel: () => {
        }
      })
    },
    // 检查单列表
    checkReportList () {
      if (this.$store.state.prvateConsultation.orderId != '') {
        Object.assign(this.$data, this.$options.data())

        let tempObj = _.cloneDeep(this.baseData)
        this.inputData = [tempObj]

        api.adminCheckReportList({
          data: {
            params: {
              orderId: this.$store.state.prvateConsultation.orderId
            }
          }
        }).then(res => {
          if (res.code == '0') {
            this.totalPrice = res.data.amount
            let touxinxi = this.showCheckUpArr[0].touxinxi

            res.data.list.map((x, index) => {
              let neirong = _.cloneDeep(this.showCheckUpArr[0].neirong)

              this.$set(neirong[0][0], 'value', x.reportId)
              this.$set(neirong[0][1], 'value', x.statusText)
              this.$set(neirong[0][2], 'value', x.name)
              this.$set(neirong[0][3], 'value', x.exeDept)
              this.$set(neirong[0][4], 'value', x.body)
              this.$set(neirong[0][5], 'value', this.$store.state.auth.info.deptName)
              this.$set(neirong[0][6], 'value', this.$store.state.auth.info.userName)
              this.$set(neirong[0][7], 'value', x.time)
              this.$set(neirong[0][8], 'value', new Number(x.price).toFixed(2))
              this.$set(neirong[0][9], 'value', x.count)
              this.$set(neirong[0][10], 'value', new Number(x.count * x.price).toFixed(2))
              this.$set(neirong[0][11], 'value', x.remark)
              this.$set(neirong[0][12], 'status', x.status)
              this.$set(neirong[0][12], 'statusText', x.statusText)
              this.$set(this.showCheckUpArr, index,
                {
                  // touxinxi: touxinxi,
                  neirong: neirong
                }
              )
            })

            this.$set(this.showCheckUpArr[0], 'touxinxi', touxinxi)
          }
        })
      }
    },
    // 搜索项目名称
    searchCheckItem (searchName) {
      this.suggestnameDataLoading = true
      api.adminSearchCheckItem({
        data: {
          params: {
            keyword: searchName,
            page_size: 20,
            page_no: 1
          }
        }
      }).then(res => {
        this.suggestnameDataLoading = false
        if (res.code == '0') {
          res.data.list.map((item, index) => {
            this.$set(this.suggestnameData, index, item.name)
            this.popDataLength = this.suggestnameData.length
            item.count = 1
            this.$set(this.suggestTabData, index, item)
          })
          this.suggestTabData.length > 0 && this.$set(this.suggestexeDeptData, 0, this.suggestTabData[this.checkedIndex].exeDept)
          this.suggestTabData.length > 0 && this.$set(this.suggestbodyData, 0, this.suggestTabData[this.checkedIndex].body)
        }
      })
    },
    // 搜索执行科室
    searchCheckDep (searchName) {
      api.adminSearchCheckDep({
        data: {
          params: {
            keyword: searchName
          }
        }
      }).then(res => {
        // console.log(res);
        if (res.code == '0') {
        }
      })
    },
    // 名称搜索 延时请求处理
    delayRequest: function (newValue, i, funName) {
      var that = this
      var j = 5
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(function () {
        ++i
        if (i == j) {
          switch (funName) {
            case 'adminSearchCheckItem':
              that.searchCheckItem(newValue)
              break
            case 'adminSearchCheckDep':
              // that.searchCheckDep(newValue);
              break
            default:

              break
          }

          clearInterval(that.timer)
        }
      }, 100)
    },
    // 回车事件
    enterEvent (e) {
      let mark = e.target.dataset.key
      let index = e.target.dataset.index // 哪一行输入框的index
      if (mark == 'jianchadanbeizhu') {
        // if (this.inputData.length >= 5) return;
        for (let i of this.inputData[index]) {
          if (i.value == '' && i.key != 'jianchadanbeizhu') {
            this.$Message.error('请补全当前行检查单信息')
            return
          }
        }
        let tempObj = _.cloneDeep(this.baseData)
        let dom = document.getElementsByClassName('all-check-up-box')[0]
        this.inputData.push(tempObj)
        if (this.checkedIndexArr.length === this.inputData.length) {
          dom.checked = true
        } else {
          dom.checked = false
        }
        this.buttomTotalPriceFun()
        this.$nextTick(() => {
          this.jumpFocus(Number(index) + 1, 'name')
        })
      } else if (mark == 'name') {
        if (this.showSuggestnameTab) {
          this.suggestTabDataClick()
        } else {
          this.jumpFocus(this.inputIndex, 'exeDept')
        }
      } else if (mark == 'exeDept') {
        if (this.showSuggestexeDeptPop) {
          this.suggestexeDeptClick()
        } else {
          this.jumpFocus(this.inputIndex, 'body')
        }
      } else if (mark == 'body') {
        if (this.showSuggestbodyPop) {
          this.suggestbodyClick()
        } else {
          this.jumpFocus(this.inputIndex, 'count')
        }
      } else if (mark == 'count') {
        this.jumpFocus(this.inputIndex, 'jianchadanbeizhu')
      }
    },
    // 鼠标移入事件
    mouseenterEvent (e) {
      this.checkedIndex = e.target.dataset.index
    },
    // 联想项目名称层鼠标点击事件
    suggestTabDataClick (e) {
      let index = this.inputIndex // 哪一行输入框的index
      this.inputData[index][0].value = this.suggestTabData[this.checkedIndex][
        'name'
      ]
      this.inputData[index][1].value = this.suggestTabData[this.checkedIndex][
        'exeDept'
      ]
      this.inputData[index][2].value = this.suggestTabData[this.checkedIndex][
        'body'
      ]
      this.inputData[index][3].value = this.suggestTabData[this.checkedIndex][
        'price'
      ]
      this.inputData[index][4].value = this.suggestTabData[this.checkedIndex][
        'count'
      ]
      this.inputData[index][5].value = (
        parseInt(this.suggestTabData[this.checkedIndex]['count']) *
        parseInt(this.suggestTabData[this.checkedIndex]['price'])
      ).toFixed(2)
      this.inputData[index][7].value = this.suggestTabData[this.checkedIndex][
        'code'
      ]
      this.inputData[index][8].value = this.suggestTabData[this.checkedIndex][
        'itemType'
      ]
      this.inputData[index][9].value = this.suggestTabData[this.checkedIndex][
        'itemSubType'
      ]
      this.$set(this.suggestexeDeptData, 0, this.suggestTabData[this.checkedIndex].exeDept)
      this.$set(this.suggestbodyData, 0, this.suggestTabData[this.checkedIndex].body)
      this.closeAllPop()
      this.jumpFocus(this.inputIndex, 'jianchadanbeizhu')
      this.buttomTotalPriceFun()
    },
    // 执行科室点击事件
    suggestexeDeptClick () {
      this.inputData[this.inputIndex][1].value = this.suggestexeDeptData[
        this.checkedIndex
      ]
      this.closeAllPop()
      this.jumpFocus(this.inputIndex, 'body')
    },
    // 部位点击事件
    suggestbodyClick () {
      this.inputData[this.inputIndex][2].value = this.suggestbodyData[
        this.checkedIndex
      ]
      this.closeAllPop()
      this.jumpFocus(this.inputIndex, 'count')
    },
    // 设置各种弹层定位
    setSuggestTabDataTop (index, name) {
      let domArr = []
      for (let i = 0; i < document.all.length; i++) {
        if (document.all[i].type == 'text') {
          domArr.push(document.all[i])
        }
      }
      for (let m = 0; m < domArr.length; m++) {
        if (
          domArr[m].dataset.index === index &&
          domArr[m].dataset.key === name
        ) {
          let clientHeight = document.documentElement.clientHeight
          if ((domArr[m].getBoundingClientRect().y + (domArr[m].getBoundingClientRect().height + 1) * 6) > clientHeight) {
            this.suggestTabDataTop =
            domArr[m].getBoundingClientRect().y - (domArr[m].getBoundingClientRect().height + 1) * 5
            this.suggestTabDataLeft = domArr[m].getBoundingClientRect().x - 1
          } else {
            this.suggestTabDataTop =
            domArr[m].getBoundingClientRect().y +
            domArr[m].getBoundingClientRect().height +
            1
            this.suggestTabDataLeft = domArr[m].getBoundingClientRect().x - 1
          }
          break
        }
      }
    },
    // 点击时联想弹出
    clickEvent (e) {
      let that = this
      function setsuggest (obj) {
        let clientHeight = document.documentElement.clientHeight
        if ((obj.getBoundingClientRect().y + (obj.getBoundingClientRect().height + 1) * 6) > clientHeight) {
          that.suggestTabDataTop =
          obj.getBoundingClientRect().y - (obj.getBoundingClientRect().height + 1) * 5
          that.suggestTabDataLeft = obj.getBoundingClientRect().x - 1
        } else {
          that.suggestTabDataTop =
          obj.getBoundingClientRect().y +
          obj.getBoundingClientRect().height +
          1
          that.suggestTabDataLeft = obj.getBoundingClientRect().x - 1
        }
      }
      let mark = e.target.dataset.key
      let value = e.target.innerText
      let index = e.target.dataset.index // 哪一行输入框的index
      this.closeAllPop()
      if (mark == 'exeDept') {
        if (value != '') {
          this.inputIndex = index
          this.checkedIndex = 0
          this.showSuggestexeDeptPop = true
          setsuggest(e.target)

          this.delayRequest(value, 0, 'adminSearchCheckDep')
          this.popDataLength = this.suggestexeDeptData.length
        } else {
          this.checkedIndex = 0
          this.showSuggestexeDeptPop = false
        }
      } else if (mark == 'body') {
        if (value != '') {
          this.inputIndex = index
          this.checkedIndex = 0
          this.showSuggestbodyPop = true
          setsuggest(e.target)
          this.popDataLength = this.suggestbodyData.length
        } else {
          this.checkedIndex = 0
          this.showSuggestbodyPop = false
        }
      }
    },
    // 输入事件
    inputEvent (e) {
      let mark = e.target.dataset.key
      let value = e.target.value
      let index = e.target.dataset.index // 哪一行输入框的index
      this.closeAllPop()
      if (mark == 'name') {
        if (value != '') {
          this.inputIndex = index
          this.checkedIndex = 0
          this.showSuggestnameTab = true
          this.setSuggestTabDataTop(index, 'name')
          this.inputData[index].map(item => {
            if (item.key != 'name') {
              item.value = ''
            }
          })

          this.delayRequest(value, 0, 'adminSearchCheckItem')
        } else {
          this.checkedIndex = 0
          this.showSuggestnameTab = false
        }
      } else if (mark == 'exeDept') {
        if (value != '') {
          this.inputIndex = index
          this.checkedIndex = 0
          this.showSuggestexeDeptPop = true
          this.setSuggestTabDataTop(index, 'exeDept')

          this.delayRequest(value, 0, 'adminSearchCheckDep')
          this.popDataLength = this.suggestexeDeptData.length
        } else {
          this.checkedIndex = 0
          this.showSuggestexeDeptPop = false
        }
      } else if (mark == 'body') {
        if (value != '') {
          this.inputIndex = index
          this.checkedIndex = 0
          this.showSuggestbodyPop = true
          this.setSuggestTabDataTop(index, 'body')
          this.popDataLength = this.suggestbodyData.length
        } else {
          this.checkedIndex = 0
          this.showSuggestbodyPop = false
        }
      } else if (mark == 'count') {
        value = value || 0
        this.inputData[index][5].value = (
          parseInt(value) * (this.inputData[index][3].value || 0)
        ).toFixed(2)
        this.buttomTotalPriceFun()
      }
    },
    // 选择联想出的信息
    changeSuggestTabEvent (e) {
      if (
        this.showSuggestnameTab ||
        this.showSuggestexeDeptPop ||
        this.showSuggestbodyPop
      ) {
        if (e.code == 'ArrowDown') {
          this.checkedIndex = ++this.checkedIndex
          if (this.checkedIndex > this.popDataLength - 1) {
            this.checkedIndex = 0
          }
        } else if (e.code == 'ArrowUp') {
          this.checkedIndex = --this.checkedIndex
          if (this.checkedIndex < 0) {
            this.checkedIndex = this.popDataLength - 1
          }
        }
      }
    },
    // 全选
    checkAllIndex () {
      let dom = document.getElementsByClassName('all-check-up-box')[0]
      let inputDom = document.getElementsByClassName('check-up-box-style')
      if (dom.checked) {
        this.checkedIndexArr = []
        this.inputData.map((item, index) => {
          this.checkedIndexArr.push(index)
        })
      } else {
        this.checkedIndexArr = []
      }
      for (let i = 0; i < inputDom.length; i++) {
        inputDom[i].checked = dom.checked
      }
    },
    // 单选
    checkIndex (e) {
      let index = Number(e.target.dataset.inputdataindex)
      let dom = document.getElementsByClassName('all-check-up-box')[0]
      let inputDom = document.getElementsByClassName('check-up-box-style')[
        index
      ]
      if (inputDom.checked) {
        this.checkedIndexArr.push(index)
      } else {
        this.checkedIndexArr.map((item, i) => {
          if (item == index) {
            this.checkedIndexArr.splice(i, 1)
          }
        })
      }
      if (this.checkedIndexArr.length === this.inputData.length) {
        dom.checked = true
      } else {
        dom.checked = false
      }
    },
    // 删除选择的检查单
    deleteInputData () {
      let inputDom = document.getElementsByClassName('check-up-box-style')
      let dom = document.getElementsByClassName('all-check-up-box')[0]
      let tempArr = _.cloneDeep(this.inputData)
      this.checkedIndexArr.map((item, index) => {
        tempArr[item] = ''
      })
      this.inputData = []
      tempArr.map(item => {
        if (item !== '') {
          this.inputData.push(item)
        }
      })
      for (let i = 0; i < inputDom.length; i++) {
        inputDom[i].checked = false
      }
      this.checkedIndexArr = []
      if (this.inputData.length === 0) {
        let tempObj = _.cloneDeep(this.baseData)
        this.inputData.push(tempObj)
        dom.checked = false
      }
      this.buttomTotalPriceFun()
    },
    // 展示保存提示框
    showSaveModalFun () {
      for (let m = 0; m < this.inputData.length; m++) {
        for (let n of this.inputData[m]) {
          if (n.key != 'jianchadanbeizhu' && n.key != 'body' && n.value == '') {
            this.$Message.error('请补全检查单内容')
            return
          }
        }
      }
      this.showSaveModal = true
    },
    // 发送检查单信息
    addInputData () {
      let report = []
      this.inputData.map(item => {
        let obj = {
          name: item[0].value,
          exeDept: item[1].value,
          body: item[2].value,
          price: item[3].value,
          count: item[4].value,
          remark: item[6].value,
          code: item[7].value,
          itemType: item[8].value,
          itemSubType: item[9].value,
          priceUnit: '元'
        }
        report.push(obj)
      })
      if (this.$store.state.prvateConsultation.orderId != '') {
        api.adminSendCheckReport({
          data: {
            params: {
              orderId: this.$store.state.prvateConsultation.orderId,
              report: report
            }
          }
        }).then(res => {
          this.buttomTotalPrice = '0.00'
          if (res.code == '0') {
            this.checkReportList()
          } else {
            this.$Message.error('检查单发送失败')
          }
        })
      } else {
        this.$Message.error('订单不存在')
      }
    },
    // 跳转光标
    jumpFocus (index, name) {
      let domArr = []
      for (let i = 0; i < document.all.length; i++) {
        if (document.all[i].type == 'text') {
          domArr.push(document.all[i])
        }
      }
      for (let m = 0; m < domArr.length; m++) {
        if (
          domArr[m].dataset.index == index &&
          domArr[m].dataset.key === name
        ) {
          this.inputIndex = index
          domArr[m].focus()
          break
        }
      }
    },
    // 隐藏所有弹层
    closeAllPop () {
      this.showSuggestnameTab = false
      this.showSuggestexeDeptPop = false
      this.showSuggestbodyPop = false
    },
    // 计算合计金额
    buttomTotalPriceFun () {
      this.buttomTotalPrice = 0.00
      this.inputData.map(item => {
        item.map(childItem => {
          if (childItem.key == 'jine') {
            this.buttomTotalPrice += parseFloat(childItem.value || 0)
          }
        })
      })
      this.buttomTotalPrice = (this.buttomTotalPrice).toFixed(2)
    },
    // 初始化表格
    init () {
      let tempObj = _.cloneDeep(this.baseData)
      this.inputData = [tempObj]
    }
  },
  created () {
    this.init()
    this.checkReportList()
  },
  computed: {
    ...mapGetters({
      headerUserRest: 'prvateConsultation/headerUserRest',
      showIMStore: 'prvateConsultation/showIM',
      showIMTime: 'prvateConsultation/showIMTime',
      userInfo: 'auth/info',
      orderId: 'prvateConsultation/orderId'
    })
  },
  watch: {
    orderId: function (val) {
      this.checkReportList()
    },
    inputData: {
      handler (newName, oldName) {
        if (parseInt(newName[0][5].value) > 0) {
          this.buttomTotalPriceIsShow = true
        } else {
          this.buttomTotalPriceIsShow = false
        }
      },
      deep: true
    }
  }
}
</script>

<style>
.check-wrap {
 width: 100%;
  height: 100%;
  font-size: 9px;
  color: #333333;
  display:flex;
  flex-direction: column;
  justify-content: flex-start;
}
.show-check-wrap {
  height: 45vh;
  overflow-y: scroll;
}
.show-check-wrap .total-price{
  display: block;
  padding-top: 5px;
  text-align: right;
}
.create-check-wrap {
  height: 30vh;
  position: relative;
  overflow-y: auto;
}
.table-wrap {
  width: 100%;
}
.table-wrap .table-header,
.create-check-wrap .table-header {
  min-height: 20px;
  background: #fff;
  white-space: nowrap;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.table-wrap .table-header > div,
.table-wrap .table-content > div,
.create-check-wrap .table-header > div {
  flex: 1;
  min-height: 20px;
  border-right: 1Px solid #ebebeb;
  border-bottom: 1Px solid #ebebeb;
  word-break: break-word;
  text-align: center;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 10px;
  overflow: hidden;
}
.create-check-wrap .table-content > div {
  flex: 1;
  height: 20px;
  border-right: 1Px solid #ebebeb;
  border-bottom: 1Px solid #ebebeb;
  box-sizing: border-box;
  line-height: 20px;
  text-align: center;
  position: relative;
}
.show-check-wrap .table-content > div > div.name{
    /* white-space: nowrap;
    text-overflow: ellipsis; */
    width: 100%;
    overflow: hidden;
}
.table-wrap .table-content,
.create-check-wrap .table-content {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  min-height: 20px;
  background: #fff;
}
.table-wrap .table-content .fun-btn-style {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.table-wrap .table-content .fun-btn-style > div {
  width: 45%;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #4aa5fe;
  border-radius: 2px;
  color: #fff;
  font-size: 9px;
  white-space: nowrap;
  cursor: pointer;
}
.create-check-wrap .table-content input {
  width: 99%;
  height: 100%;
  border: none;
  text-align: center;
}
.create-check-wrap .table-content input:focus {
  outline: none;
}
.title-info {
  height: 20px;
  padding: 10px 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  line-height: 20px;
}
.title-info > div {
  width: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title-info > div > div {
  width: 45px;
  height: 18px;
  background: #4aa5fe;
  border-radius: 4px;
  color: #fff;
  font-size: 10px;
  line-height: 18px;
  text-align: center;
  cursor: pointer;
}
.create-check-wrap .table-header .select-box,
.create-check-wrap .table-content .select-box {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  border-left: 1Px solid #ebebeb;
  border-top: 1Px solid #ebebeb;
}
.create-check-wrap .table-content .select-box {
  border-top: none;
  display: flex;
  justify-content: center;
  align-items: center;
}
.create-check-wrap .table-content .select-box > input {
  width: 10px;
  height: 10px;
}
.create-check-wrap .table-content .suggest-table-wrap {
  height: 20px;
  position: fixed;
  top: 0px;
  left: 0px;
  border: none;
  background: #fff;
  z-index: 9999;
}
.create-check-wrap .table-content .suggest-table-wrap .table-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.create-check-wrap .table-content .suggest-table-wrap .table-header > div {
  width: 71.5px;
  height: 20px;
}
.create-check-wrap .table-content .suggest-table-wrap .table-content > div {
  width: 102px;
  min-height: 20px;
  display: inline-block;
  overflow: hidden;
  cursor: pointer;
}
.table-wrap .table-content, .create-check-wrap .table-content .XiangMuMing-relative{
  position: relative;
}
.create-check-wrap .table-content .suggest-pop-wrap {
  position: absolute;
  width: 150px;
  height: 100px;
  display: block;
  top: 0.625rem;;
  left: 0;
  border: 1Px solid #ebebeb;
  background: #fff;
  overflow-y:scroll;
}
.create-check-wrap .table-content .suggest-pop-wrap > div {
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
}
.create-check-wrap .total-price-style{
    width: 100%;
   text-align: right;
   margin-top: 5px;
}

.demo-spin-col{
    height: 100%;
    width: 100%;
    position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/private_consultation_page/fun_right/check_up_page/index.vue